function updateStickyOffsets() {
    const topbar = document.querySelector('.topbar-section');
    const header = document.querySelector('.header-section');

    if (topbar && header) {
        const topbarHeight = topbar.offsetHeight;
        const headerHeight = header.offsetHeight;
        const totalOffset = topbarHeight + headerHeight;

        document.documentElement.style.setProperty('--topbar-height', `${topbarHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        document.documentElement.style.setProperty('--total-sticky-offset', `${totalOffset}px`);
    }
}

// Update on load and resize
window.addEventListener('load', updateStickyOffsets);
window.addEventListener('resize', updateStickyOffsets);

// Also update when fonts load (common cause of layout shifts)
if (document.fonts) {
    document.fonts.ready.then(updateStickyOffsets);
}